//@flow
import * as React from 'react';
import {baseClass} from "../../../../pages/UiKit/newUiKit/utilities/baseClass";
import type {children, id, onClick} from "../../../../services/flowTypes/appFlowTypes";
import type {addClasses} from "../../../../services/flowTypes/uiKitFlowTypes";
import './DelFilterBtn.css';

type Props = {
  id?: id,
  addClasses?: addClasses,
  children: children,
  onClick: onClick
};

const DelFilterBtn = (props: Props) => {
  return (
    <button type="button" id={props.id} onClick={props.onClick}
         className={baseClass("DelFilterBtn", props.addClasses)}/>
  );
};

export default DelFilterBtn;